<script setup lang="ts">
  import { Loader2 } from 'lucide-vue-next'
  import { Button } from '@/components/ui/button'
  import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle
  } from '@/components/ui/dialog'
  import { Textarea } from '@/components/ui/textarea'

  defineProps<{
    open: boolean
    noteText: string
    saving?: boolean
    dialogTitle: string
    placeholder: string
    saveLabel: string
    cancelLabel: string
  }>()

  const emit = defineEmits<{
    'update:open': [value: boolean]
    'update:noteText': [value: string]
    save: []
  }>()
</script>

<template>
  <Dialog
    :open="open"
    @update:open="emit('update:open', $event)"
  >
    <DialogContent
      data-cy="call-note-dialog"
      class="max-w-lg"
    >
      <DialogHeader>
        <DialogTitle data-cy="call-note-dialog-title">{{ dialogTitle }}</DialogTitle>
        <DialogDescription class="sr-only">{{ placeholder }}</DialogDescription>
      </DialogHeader>
      <div class="space-y-4">
        <Textarea
          data-cy="call-note-textarea"
          :model-value="noteText"
          :placeholder="placeholder"
          class="min-h-[120px] resize-none"
          :disabled="saving"
          @update:model-value="emit('update:noteText', String($event ?? ''))"
        />
        <div class="flex justify-end gap-2">
          <Button
            data-cy="call-note-cancel"
            variant="outline"
            :disabled="saving"
            @click="emit('update:open', false)"
          >
            {{ cancelLabel }}
          </Button>
          <Button
            data-cy="call-note-save"
            :disabled="saving"
            @click="emit('save')"
          >
            <Loader2
              v-if="saving"
              class="mr-2 h-4 w-4 animate-spin"
            />
            {{ saveLabel }}
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>
